import { IUserProfile } from "./IUserProfile";

export class UserProfile implements IUserProfile {
    id: string;
    firstName: string;
    email: string;
    roles: string[];
    isAdmin: boolean;
    isAccountant: boolean;
    isTeacher: boolean;

    public static fromUserProfileData(profile: IUserProfile): IUserProfile {
        return new UserProfile(profile.id, profile.firstName, profile.email, profile.roles);
    }

    public static emptyProfile() {
        return new UserProfile("", "", "", []);
    }

    public inRole(role: string): boolean {
        return this.roles && this.roles.indexOf(role)!=-1;
    }

    constructor(id: string, firstName: string, email: string, roles: string[]) {
        this.id = id;
        this.firstName = firstName;
        this.email = email;
        this.roles = [...roles];
        this.isAdmin = this.roles.indexOf("UserAdmin") > -1;
        this.isAccountant = this.roles.indexOf("Accountant") > -1;
        this.isTeacher = this.roles.indexOf("Teacher") > -1;
        
    }
}